export const menu = [
    {
        img: require("./images/pesto.jpg"),
        bestseller: true,
        name: "Pesto pasta",
        price: 300,
        count: "c1",
    },
    {
        img: require("./images/pasta.jpg"),
        bestseller: false,
        name: "Seafood pasta",
        price: 400,
        count: "c2",
    },
    {
        img: require("./images/carbonara.jpg"),
        bestseller: false,
        name: "Carbonara pasta",
        price: 310,
        count: "c3",
    },
    {
        img: require("./images/tagliatelle.jpg"),
        bestseller: false,
        name: "Tagliatelle pasta",
        price: 350,
        count: "c4",
    },
    {
        img: require("./images/ravioli.jpg"),
        bestseller: false,
        name: "Ravioli with burnt butter sauce",
        price: 500,
        count: "c5",
    },
    {
        img: require("./images/lasagna.jpg"),
        bestseller: false,
        name: "Lasagna",
        price: 550,
        count: "c6",
    },
    {
        img: require("./images/veg-ravioli.jpg"),
        bestseller: false,
        name: "Veg Ravioli",
        price: 500,
        count: "c7",
    },
    {
        img: require("./images/pizza-pasta.jpg"),
        bestseller: false,
        name: "Pizza pasta",
        price: 600,
        count: "c8",
    },
    {
        img: require("./images/pepperono.jpg"),
        bestseller: false,
        name: "Pepperoni pizza",
        price: 440,
        count: "c9",
    },
    {
        img: require("./images/tomato-pizza.jpg"),
        bestseller: false,
        name: "Vegetarian Pizza",
        price: 490,
        count: "c10",
    },
    {
        img: require("./images/olive.jpg"),
        bestseller: false,
        name: "Pepperoni and Olive",
        price: 550,
        count: "c11",
    },
    {
        img: require("./images/margherita.jpg"),
        bestseller: false,
        name: "Margherita",
        price: 300,
        count: "c12",
    },
    {
        img: require("./images/tiramasu.jpg"),
        bestseller: true,
        name: "Tiramasu",
        price: 250,
        count: "c13",
    },
    {
        img: require("./images/bundt-cake.jpg"),
        bestseller: false,
        name: "Chocolate bundt cake",
        price: 200,
        count: "c14",
    },
    {
        img: require("./images/brownie.jpg"),
        bestseller: false,
        name: "Brownie with ice cream",
        price: 270,
        count: "c15",
    },
    {
        img: require("./images/papaya-cake.jpg"),
        bestseller: false,
        name: "Coconut Papaya cake",
        price: 290,
        count: "c16",
    },
    {
        img: require("./images/cheesecake.jpg"),
        bestseller: false,
        name: "Chocolate Cheesecake",
        price: 290,
        count: "c18",
    },
    {
        img: require("./images/tart.jpg"),
        bestseller: false,
        name: "Lemon curd tart",
        price: 290,
        count: "c19",
    },
    {
        img: require("./images/pudding.jpg"),
        bestseller: false,
        name: "Chocolate Pudding",
        price: 290,
        count: "c20",
    },
    {
        img: require("./images/spinach-cake.jpg"),
        bestseller: false,
        name: "Spinach cake",
        price: 290,
        count: "c21",
    },
]